import { SendAnvisaDocumentUI } from './sendAnvisaDocumentUI'
import { useSendDocuments } from '../../hooks/useSendDocuments/useSendDocuments'

function SendAnvisaDocument() {
  const props = useSendDocuments()
  return <SendAnvisaDocumentUI {...props} />
}

export default SendAnvisaDocument